import React from 'react';
import { useUserProfile } from '@/features/profile/hooks/useUserProfile';
import { useI18n } from '@/contexts/I18nContext';

const GreetingSection: React.FC = () => {
  const { profile, isLoading } = useUserProfile();
  const { t } = useI18n();

  const getFirstName = (fullName: string) => {
    return fullName.split(' ')[0];
  };

  return (
    <div className="mb-6">
      <div className="rounded-lg text-white">
        <div className="flex items-center justify-between">
          <div>
            <h1 className="text-2xl font-bold mb-2">
              {t('home.greeting.title', { 
                name: profile?.full_name ? getFirstName(profile.full_name) : 'Fighter' 
              })}
            </h1>
            <p className="text-gray-300 text-[12px] font-light">
              {t('home.greeting.subtitle')}
            </p>
          </div>
        </div>
      </div>
    </div>
  );
};

export default GreetingSection;
